'use strict'

const identity_ = require('lodash/identity')
const mergeWith_ = require('lodash/mergeWith')
const mapValues_ = require('lodash/mapValues')
const omit_ = require('lodash/omit')
const has_ = require('lodash/has')
const {
  configureForViewerWorker
} = require('@wix/dbsm-common/src/raven/configureForViewerWorker')

const addDataFixer = raven => {
  const removeRecordsIfExists = value =>
    has_(value, 'state.records') ? omit_(value, 'state.records') : value

  const removeUserData = data => mapValues_(data, removeRecordsIfExists)

  raven.setDataCallback((data, originalCallback = identity_) => {
    mergeWith_(data.extra, (objValue, srcValue) => {
      // We customize the serializer because of this bug:
      // https://github.com/origamitower/folktale/issues/190
      if (srcValue && srcValue[Symbol.for('@@folktale:adt:tag')]) {
        return srcValue.toJSON()
      }
    })

    const finalData = originalCallback(data)
    finalData.extra = removeUserData(finalData.extra)

    return finalData
  })
}

module.exports = (Raven, globalScope, dsn, params, appName) => {
  configureForViewerWorker({ Raven, globalScope, dsn, params, appName })

  addDataFixer(Raven)
}
